export default __webpack_public_path__ + "static/media/custj.d4be65d9.jpg";